/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"PljFG9":["Your eligibility could not be determined."],"BzZl3Q":["This could be caused by a temporary problem. Try again in a few minutes."],"Yx8z71":["A checkout session could not be started."],"65/YkY":["Hi! Thank you for your interest in Khanmigo."],"FK+RFI":["Khanmigo does not yet fully support your selected language. If you’d like to learn more about Khanmigo, <0>please visit this page</0>."],"iYHVLU":["Thank you for your interest and sorry for the inconvenience."],"avdD+7":["Khanmigo is not yet available in your region. <0>Sign up to get notified</0> when Khanmigo for Teachers is available in your country."],"y/hQEi":["Khanmigo is not yet available in your region."],"OyC82v":["Your country isn’t eligible right now."],"9NycSw":["Uh oh! You don’t have a birthday set on your account."],"jSU9fH":["If you want to use Khanmigo, please <0>go to your account settings</0> and add your birthday."],"waBKnX":["As a reminder, to participate you'll need to be age 18 or older and live in the United States. If you are under 18 and want to test Khanmigo, your parent or guardian needs to sign up."],"vXWqF0":["If you want to use Khanmigo, your parent or guardian needs to sign up."],"zrVypj":["At this time, only people ages 18 and older are eligible to sign up. Please ask your parent or guardian to sign up and add you to their account."],"jVSRT+":["Khanmigo: By Khan Academy"],"BADUYp":["Get Khanmigo"]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["ur","te","ro","km","zh-hant","uz","ta","sv","sk","sgn-us","rw","ru","pt-pt","my","mn","lt","ky","kn","kk","is","gu","fv","en-x-rtl","as","zu","xh","th","sw","fa","ms","he","fa-af","ar","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["es","zh-hans","vi","uk","tr","sr","pt","pl","pa","or","nb","ko","ka","hy","hi","fr","de","bn","bg","nl","mr","lv","lol","ja","it","id","hu","en-pt","el","da","cs","boxes","az","accents"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
